import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { SubscriptionBasedComponent } from '../../subscription-helpers/subscription-based.component';
import UserHelper from '../../helpers/user-helper';
import { User } from 'src/app/model/user';
import * as globals from '../../../globals/globals';
import { FeatureFlagService } from '../../services/feature-flag.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  loginForm: any;
  message: string;
  shouldShowLoginUI: boolean = false;

  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private featureFlagService: FeatureFlagService
  ) {
    super();
    this.loginForm = this.fb.group({
      login: ['', [Validators.required]],
      password: ['', [Validators.required]],
      persist: [false, []],
    });
  }

  ngOnInit() {
    this.route.data.subscribe((data) => {
      if (
        data['shouldHandleVELogin'] !== false &&
        this.featureFlagService.shouldAuthenticateWithVE()
      ) {
        this.shouldShowLoginUI = false;
        this.loginViaVE();
      } else {
        this.shouldShowLoginUI = true;
      }
    });

    this.addSubscription(this.authService.loginevent, (user: User) => {
      if (UserHelper.isPlacer(user)) {
        this.router.navigateByUrl('/installateur');
      } else if (UserHelper.isAtelier(user)) {
        this.router.navigateByUrl('/atelier');
      } else if (UserHelper.isClient(user)) {
        if (user.hasNewPortalAccess) {
          window.location.href = globals.newPortalUrl;
        } else {
          this.router.navigateByUrl('/client-corner/lopende');
        }
      } else {
        this.router.navigateByUrl('/projecten');
      }
    });
  }

  login() {
    this.authService.login(
      this.loginForm.value.login,
      this.loginForm.value.password
    );
  }

  private loginViaVE() {
    const clientId = environment.veClientId;
    const redirectURI = encodeURIComponent(
      document.location.origin + '/auth_redirect'
    );
    const state = this.authService.generateAndStoreSessionState();

    document.location.href = `https://erpve.be/klantenportaal_login/?client_id=${clientId}&redirect_uri=${redirectURI}&state=${state}`;
  }
}
